var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5","transform":"translate(2 2)"},[React.createElement("rect",{"width":"9.1","height":"9.1","x":"4.9","y":"4.9","rx":"2","key":0}),React.createElement("path",{"d":"M2.1 9.1h-.7A1.4 1.4 0 0 1 0 7.7V1.4A1.4 1.4 0 0 1 1.4 0h6.3a1.4 1.4 0 0 1 1.4 1.4v.7","key":1})]));
}

Copy.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18"};

module.exports = Copy;

Copy.default = Copy;
